import { PayloadAction, createSelector } from '@reduxjs/toolkit';
import { InboxReducerState } from './types';
import { RootState } from '../../../../store';
import { createExtendedSlice } from 'src/store/createExtendedSlice';
import { LogMsgFailed } from 'src/app/store/routingSlice/types';
import { initialState } from './utils';

const sliceName = 'InboxView';

// =============================
// ------- Slice ----------
// =============================
export const InboxViewSlice = createExtendedSlice({
  name: sliceName,
  initialState,
  reducers: {
    // ---- Internal ---
    inboxViewInit: (state) => {},
    inboxViewFetchDashboardRequest: (state) => {},
    inboxViewFetchDashboardSuccess: (
      state,
      { payload }: PayloadAction<InboxReducerState['data']>,
    ) => {
      state.data = payload;
    },
    inboxViewFetchDashboardFailed: (
      state,
      { payload }: PayloadAction<LogMsgFailed>,
    ) => {},
    inboxViewResetControlFilters: (state) => {
      // state.filters.controls = initialState.filters.controls;
    },
    inboxViewSetControlFilters: (
      state,
      // { payload }: PayloadAction<ReceiptsReducerState['filters']['controls']>,
    ) => {
      // state.filters.controls = payload;
    },
  },
});

// =============================
// ------- selectors ----------
// =============================
export const getInboxViewFiltersData = (state: RootState) =>
  state.inboxView.filters;

export const getInboxViewData = (state: RootState) => state.inboxView.data;

export const getInboxViewDataInboxes = createSelector(
  getInboxViewData,
  (data) => data?.inboxes,
);

// =============================
// ------- Exports ----------
// =============================

export const {
  inboxViewInit,
  inboxViewFetchDashboardRequest,
  inboxViewFetchDashboardSuccess,
  inboxViewFetchDashboardFailed,
  inboxViewResetControlFilters,
  inboxViewSetControlFilters,
} = InboxViewSlice.actions;

export default InboxViewSlice.reducer;
